/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrEventEntity } from '../../models/dbr-event-entity';

export interface EventsControllerFindOne$Params {
  id: number;
}

export function eventsControllerFindOne(http: HttpClient, rootUrl: string, params: EventsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrEventEntity>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrEventEntity>;
    })
  );
}

eventsControllerFindOne.PATH = '/events/{id}';
